import { readFormConfig } from '@/modules/forms/formConfig';

export const WEALTHHUB_TRUST_REVIEW_OBJECT =
  'TrustHub__Trust_Document_Review2__c';

const WEALTHHUB_LEGAL_ENTITY_OBJECT = 'TrustHub__Legal_Entity__c';
/** The Legal Entity lookup to its parent Household or Family Account. */
const WEALTHHUB_LEGAL_ENTITY_ACCOUNT_FIELD = 'TrustHub__Client__c';

/**
 * Returns the Salesforce Lightning URL of the New Legal Entity page, with the
 * Account lookup set to `accountID`. Salesforce supplies the record type
 * choice, page layout, and validation. The user must sign in to Salesforce.
 * Luminary does not learn the result; the caller reloads the entities instead.
 */
export function wealthHubLegalEntityCreateURL(
  domain: string,
  accountID: string
): string {
  const defaults = `${WEALTHHUB_LEGAL_ENTITY_ACCOUNT_FIELD}=${encodeURIComponent(accountID)}`;
  return `https://${domain}/lightning/o/${WEALTHHUB_LEGAL_ENTITY_OBJECT}/new?defaultFieldValues=${defaults}`;
}

/** Reports whether reviews of this Form version export to WealthHub. */
export function exportsToWealthHubTrustReview(formVersion: {
  schemaVersion: number;
  config: unknown;
}): boolean {
  return (
    readFormConfig(formVersion.schemaVersion, formVersion.config)?.exports
      ?.salesforce?.objectAPIName === WEALTHHUB_TRUST_REVIEW_OBJECT
  );
}

export interface SalesforcePicklistValue {
  label: string;
  value: string;
  active: boolean;
}

/** Salesforce field metadata normalized for Form authoring. */
export interface SalesforceFieldDescription {
  apiName: string;
  label: string;
  type: string;
  custom: boolean;
  createable: boolean;
  nillable: boolean;
  calculated: boolean;
  autoNumber: boolean;
  defaultedOnCreate: boolean;
  length: number;
  helpText: string;
  picklistValues: SalesforcePicklistValue[];
  referenceTo: string[];
}

export interface SalesforceObjectDescription {
  apiName: string;
  label: string;
  custom: boolean;
  createable: boolean;
  fields: SalesforceFieldDescription[];
}
